// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l1tb","input":"styles_input__2ZYRP"};